<template>
  <b-container>
    <b-card title="Send Email">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <template #label>
                Subject
              </template>
              <b-form-input
                v-model="form.subject"
                placeholder="Subject"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Sent to All">
              <b-form-input
                v-model="form.sendToAll"
                placeholder="Sent to All"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Division">
              <b-card class="mb-1">
                <div v-if="filteredDivision.length">
                  <b-table
                    :items="filteredDivision"
                    :fields="['#', 'division']"
                    :per-page="perPage"
                    :current-page="divisionPage"
                    small
                    responsive
                    class="mb-0"
                  >
                    <template #cell(#)="data">
                      {{ (divisionPage - 1) * perPage + data.index + 1 }}
                    </template>

                    <template #cell(division)="data">
                      {{ data.item }}
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="divisionPage"
                    :total-rows="filteredDivision.length"
                    :per-page="perPage"
                    align="right"
                    size="sm"
                    class="mt-1"
                  />
                </div>

                <div
                  v-else
                  class="text-muted text-center py-2 border rounded"
                  style="background-color: #f8f9fa;"
                >
                  No division available in To
                </div>
                <b-form-input
                  v-model="search.division"
                  placeholder="Search division in To..."
                  size="sm"
                  class="mt-2"
                />
              </b-card>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="To">
              <b-card class="mb-1">
                <div v-if="filteredTo.length">
                  <b-table
                    :items="filteredTo"
                    :fields="['#', 'email']"
                    :per-page="perPage"
                    :current-page="toPage"
                    small
                    responsive
                    class="mb-0"
                  >
                    <template #cell(#)="data">
                      {{ (toPage - 1) * perPage + data.index + 1 }}
                    </template>

                    <template #cell(email)="data">
                      {{ data.item }}
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="toPage"
                    :total-rows="filteredTo.length"
                    :per-page="perPage"
                    align="right"
                    size="sm"
                    class="mt-1"
                  />
                </div>
                <div
                  v-else
                  class="text-muted text-center py-2 border rounded"
                  style="background-color: #f8f9fa;"
                >
                  No email available in To
                </div>
                <b-form-input
                  v-model="search.to"
                  placeholder="Search email in To..."
                  size="sm"
                  class="mt-2"
                />
              </b-card>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="CC">
              <b-card class="mb-1">
                <div v-if="filteredCc.length">
                  <b-table
                    :items="filteredCc"
                    :fields="['#', 'email']"
                    :per-page="perPage"
                    :current-page="ccPage"
                    small
                    responsive
                    class="mb-0"
                  >
                    <template #cell(#)="data">
                      {{ (ccPage - 1) * perPage + data.index + 1 }}
                    </template>
                    <template #cell(email)="data">
                      {{ data.item }}
                    </template>
                  </b-table>

                  <b-pagination
                    v-model="ccPage"
                    :total-rows="filteredCc.length"
                    :per-page="perPage"
                    align="right"
                    size="sm"
                    class="mt-1"
                  />
                </div>

                <div
                  v-else
                  class="text-muted text-center py-2 border rounded"
                  style="background-color: #f8f9fa;"
                >
                  No email available in CC
                </div>

                <b-form-input
                  v-model="search.cc"
                  placeholder="Search email in CC..."
                  size="sm"
                  class="mt-2"
                />
              </b-card>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="BCC">
              <b-card class="mb-1">
                <div v-if="filteredBcc.length">
                  <b-table
                    :items="filteredBcc"
                    :fields="['#', 'email']"
                    :per-page="perPage"
                    :current-page="bccPage"
                    small
                    responsive
                    class="mb-0"
                  >
                    <template #cell(#)="data">
                      {{ (bccPage - 1) * perPage + data.index + 1 }}
                    </template>
                    <template #cell(email)="data">
                      {{ data.item }}
                    </template>
                  </b-table>

                  <b-pagination
                    v-model="bccPage"
                    :total-rows="filteredBcc.length"
                    :per-page="perPage"
                    align="right"
                    size="sm"
                    class="mt-1"
                  />
                </div>

                <div
                  v-else
                  class="text-muted text-center py-2 border rounded"
                  style="background-color: #f8f9fa;"
                >
                  No email available in BCC
                </div>

                <b-form-input
                  v-model="search.bcc"
                  placeholder="Search email in BCC..."
                  size="sm"
                  class="mt-2"
                />
              </b-card>
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group>
              <template #label>
                Content
              </template>
              <b-card class="p-2" style="min-height:150px; background:#f8f9fa;">
                <div v-html="form.content"></div>
              </b-card>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Attachment">
              <div class="d-flex flex-wrap">
                <b-button
                  v-if="attachments.length"
                  variant="outline-primary mr-1"
                  class="btn-icon"
                  @click="downloadAttachments"
                >
                  <feather-icon icon="DownloadIcon" />
                  Download{{ attachments.length > 1 ? 's' : '' }}
                </b-button>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" class="d-flex justify-content-end">
            <b-button type="button" class="mr-1" variant="light" @click="cancel">
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BForm,
  BFormGroup,
  BFormSelect,
  BFormDatepicker,
  BPagination,
  BModal,
  VBModal,
  BFormTextarea,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from "moment";
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormDatepicker,
    BImg,
    VBModal,
    BFormTextarea,
  },
  data() {
    return {
      token: '',
      attachments: [],
      form: {
        sendToAll: '',
        division: [],
        to: [],
        cc: [],
        bcc: [],
        subject: '',
        content: '',
      },
      search: {
        to: '',
        cc: '',
        bcc: '',
        division: '',
      },
      isBusy: false,
      divisionPage: 1,
      toPage: 1,
      ccPage: 1,
      bccPage: 1,
      perPage: 5
    }
  },
  computed: {
    filteredTo() {
      return this.form.to.filter(email =>
        email.toLowerCase().includes(this.search.to.toLowerCase())
      )
    },
    filteredCc() {
      return this.form.cc.filter(email =>
        email.toLowerCase().includes(this.search.cc.toLowerCase())
      )
    },
    filteredBcc() {
      return this.form.bcc.filter(email =>
        email.toLowerCase().includes(this.search.bcc.toLowerCase())
      )
    },
    filteredDivision() {
      return this.form.division.filter(division =>
        division.toLowerCase().includes(this.search.division.toLowerCase())
      )
    },
  },
  directives: {
    Ripple,
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)
  },
  mounted() {
    const id = this.$route.params.id
    this.DetailRequest(id)
  },
  methods: {
    cancel() {
      this.$router.back()
    },
    DetailRequest(id) {
      this.isBusy = true
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/notificationCenter/featuresBlast/`+id, {
        params: {},
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      }).then(({ data }) => {
        this.form.subject = data.data.subject
        this.form.sendToAll = (data?.data?.sendToAll.length > 0) ? "YES" : "NO"
        this.form.to = (data?.data?.sendToAll.length > 0) ? data.data.sendToAll : data.data.to
        this.form.cc = data.data.cc
        this.form.bcc = data.data.bcc
        this.form.division = data.data.sendByDivision
        this.form.content = data.data.content
        this.attachments = data.data.attachments
      }).finally(() => {
        this.isBusy = false
      })
    },
    downloadAttachments() {
      const id = this.$route.params.id
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/notificationCenter/${id}/attachments`, {
        responseType: 'blob',
        headers: { 'Authorization': `${this.token}` }
      }).then((response) => {
        const contentType = response.headers['content-type'] || 'application/octet-stream'
        const blob = new Blob([response.data], { type: contentType })
        const url = window.URL.createObjectURL(blob)
        let fileName = `attachments_${id}.zip`
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/)
          if (match && match[1]) {
            fileName = match[1]
          }
        } else if (this.attachments.length === 1) {
          fileName = this.attachments[0].fileName || `attachment_${id}`
        }
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch((error) => {
        console.error('Download failed:', error)
      })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
